export default __webpack_public_path__ + "static/media/1573-l3id.08b641ae.pdf";